import { store } from '@/redux/store';
import { clearHttpState, HttpState } from '@/redux/reducers/http';

export function clearHttpStateObject(coreRelationKey: keyof HttpState, data: any = null) {
  store.dispatch(clearHttpState(coreRelationKey, data));
}
